// components/PageHeader.tsx
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  rightElement?: ReactNode; // Button, Icon, etc.
}

const PageHeader = ({ title, subtitle, rightElement }: PageHeaderProps) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      mb={6}
      px={4}
      py={3}
      borderBottom="1px solid"
      borderColor="gray.200"
      bg="white"
      borderRadius="lg"
      boxShadow="sm"
    >
      <Box>
        <Heading size="md">{title}</Heading>
        {subtitle && (
          <Text fontSize="sm" color="gray.500">
            {subtitle}
          </Text>
        )}
      </Box>

      {rightElement && <Box>{rightElement}</Box>}
    </Flex>
  );
};

export default PageHeader;
